import React from 'react';
import SectionHeading from '../ui/SectionHeading';
import useReveal from '../../hooks/useReveal';
import { socials } from '../../data/content';
import './Contact.css';

export default function Contact() {
  const revealRef = useReveal();

  return (
    <section className="contact" id="contact">
      <div className="container reveal" ref={revealRef}>
        <SectionHeading eyebrow="03 · contact" title="Let's Work" accent="Together" />
        <p className="contact__subtitle">
          Ready to bring your ideas to life? Let's discuss your project.
        </p>
        <div className="contact__links">
          {socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              className="contact__link"
              target={social.href.startsWith('http') ? '_blank' : undefined}
              rel={social.href.startsWith('http') ? 'noreferrer' : undefined}
            >
              <span aria-hidden="true">{social.icon}</span>
              {social.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
